<docs>
  # Mobile screen
  > The Basic Mobile screen
  
  @author nicolas husson <nicolas@kffein.com>
</docs>

<script lang="ts">
import iconBureau from 'assets/svg/bureau.svg?raw';
import { defineComponent } from 'vue';
import imageBackground from './img/background-mobile.png';

export default defineComponent({
  name: "UiMobileScreen",
  setup() {
    // const el = templateRef('el')

    return {
      imageBackground,
      iconBureau,
    }
  }
});
</script>

<template>
  <main ref="el" class="mobile-section">
    <div class="row-container">
      <div class="content">
        <span ref="Subtitle"
              class="subtitle"
              v-html="`&quot; CRITIQUE&quot;`"
        />
        <h1 ref="title"
            class="title"
            v-text="'LA COLLECTION CLAUDE-GINGRAS'"
        />
        <i class="icon" v-html="iconBureau" />
        <div ref="description"
             class="description wysiwyg"
             v-html="`<p>Cette expérience n'est malheureusement pas optimisée pour le mobile.</p><p>Pour une immersion complète, rendez-vous sur notre site depuis un ordinateur ou une tablette.</p><p>Claude et les bibliothèques de l'Université de Montréal vous remercient!</p>`"
        />
        <i class="icon" v-html="iconBureau" />
      </div>
    </div>
    <div class="background-mobile-section">
      <ui-picture ref="image"
                  :src="imageBackground"
                  class="image -main"
                  cover="cover"
      />
    </div>
  </main>
</template>

<style lang="stylus" scoped>
  .mobile-section
    text-align center
    position relative
    f(center, column)
    .row-container
      color $c-dark_blue_udm
      margin 10px
      border 1px solid $c-dark_blue_udm
      border-radius 10px
      f(center, column)
      padding 30px 0
      min-height 100vh
      min-height 100svh
    .icon
      width 10px
      height 10px
      margin 20px 0
      :deep()
        svg
          width 100%
          height 100%

    

  .content
    f(center, column)


  .subtitle
    f-style('h2', $uppercase: true)
    display block
    rp(margin-bottom, 30px)
  .title
    f-style(h1)
    text-align center
    text-transform uppercase
    rp(margin-bottom, 60px)
    margin-left 10px
    margin-right 10px

  .subtitle
    f-style('h2', $uppercase: true)
    rp(margin-bottom, 40px)

  .description
    rp(margin-bottom, 60px)
    rp(margin-top, 60px)
    f-style('text14', $uppercase: true)
    rp(max-width, 580px)
    :deep()
      p + p
        rp(margin-top, 20px)


  .background-mobile-section
    absolute 0
    z-index -1
    :deep()
      .ui-picture
        size 100%
</style>
